import { render, staticRenderFns } from "./study-navigation.vue?vue&type=template&id=324511c6&scoped=true&"
import script from "./study-navigation.vue?vue&type=script&lang=ts&"
export * from "./study-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./study-navigation.vue?vue&type=style&index=0&id=324511c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324511c6",
  null
  
)

export default component.exports